/**
 * Normalise any Survey Manager path/query slug to kebab-case.
 * Handles spaces, "+", underscores, percent-encoding, quotes, and accents.
 */
export function toSurveyManagerSlug(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }

  let raw = String(value).trim();
  if (raw.length === 0) {
    return '';
  }

  // Unwrap common accidental JSON / quote wrappers: "\"Forward Facing\"" -> Forward Facing
  if (
    (raw.startsWith('"') && raw.endsWith('"')) ||
    (raw.startsWith("'") && raw.endsWith("'"))
  ) {
    raw = raw.slice(1, -1).trim();
  }

  // Decode percent-encoding (%20, %2B, double-encoding) before slugifying.
  for (let i = 0; i < 3; i += 1) {
    if (!/%[0-9A-Fa-f]{2}/.test(raw)) {
      break;
    }
    try {
      const decoded = decodeURIComponent(raw.replace(/\+/g, '%20'));
      if (decoded === raw) {
        break;
      }
      raw = decoded;
    } catch {
      break;
    }
  }

  // Strip diacritics so "São Paulo" -> "sao-paulo"
  const ascii = raw
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '');

  return ascii
    .toLowerCase()
    .replace(/['"]+/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}
